function isHeic(file) {
	const regex = /\.(heic|heif)$/i
	return regex.test(file.type) || regex.test(file.name)
}

export default isHeic
